module.exports = __webpack_public_path__ + "images/d07b29c8.png";